<template>
	<div id="Container" class="widget-container py-5 background--card">
		<a href="#" @click.prevent="closeSelf" class="close">
            <svg-rndr svg="close.svg" />
        </a>
        <div class="widget-contents DialogContent">
			<div class="widget-contents__inner DialogContentInner">
				<div class="row mb-4">
                    <div class="col-md-auto offset-md-1">
                        <h2 v-translate>Connection Error</h2>

                        <p class="text-white" v-translate>
							There was a problem loading your profile, please try again later.
						</p>
                    </div>
                </div>
			</div>
		</div>
	</div>
</template>

<script>
import widgetMixin from '@M/widgets/dialog';
export default {
	mixins: [widgetMixin]
}
</script>


// WEBPACK FOOTER //
// resources/assets/js/stages/Widgets/Error.vue